// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a362170","667":"4dccd9fd","977":"30499bd1"}[chunkId] + ".chunk.js";
};